import InputGroup from "components/input-group/input-group";
import Modal from "components/global/modal";
import ModalHeader from "components/global/modal-header";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import update from "immutability-helper";
import { useState } from "react";
import Button from "components/button/button";
import { usePositions } from "redux/modules/position/hooks";

const PositionEdit = ({hide,profile,getPositions = ()=>{}, jobsList=[{ job_role: "", description: "" }]})=>{
    const {t} = useTranslation();
    
    const { http } = global.services;

    const {
        positions,
      } = usePositions();

    const [jobs, setJobs] = useState(jobsList);
    const [positionOptions, setPositionOptions] = useState(positions);
    const [btnAddPositionHidden, setBtnAddPositionHidden] = useState(false);
    const [errorMessages, setErrorMessages] = useState({});
    
    const onChangeInput = (e, index) => {
        let payload = _.clone(jobs);
        let result = update(payload, {
        [index]: {
            description: { $set: e.target.value },
        },
        }); //remove
        console.log(result)
        setJobs(result);
    };

  const onAddPosition = () => {
    if (jobs.length === 5) return;

    let payload = _.clone(jobs);
    payload.push({ job_role: "", description: "" });
    setJobs(payload);

    if (jobs.length < 4) setBtnAddPositionHidden(false);
    else setBtnAddPositionHidden(true);
  };

  const onSelectJobRole = async (e, index) => {
    let _remove = jobs[index] ? jobs[index].job_role : {};
    let _value = e ? e.value : "";
    let opt = e ? e : "";

    if (!_value) {
      _remove = jobs[index].job_role;
    }

    if (e && e.__isNew__) {
      let createdPosition = await createPosition(e);
      opt = { label: createdPosition.name, value: createdPosition.id };
      _value = createdPosition.id;

      setSelectJobRole(_remove, _value, opt, index);
    } else {
      setSelectJobRole(_remove, _value, opt, index);
    }
  };

  const setSelectJobRole = (_remove, _value, opt, index) => {
    let types = positionOptions.map((op) => {
      if (op.value === _value) {
        return {
          ...op,
          selected: true,
        };
      } else if (op.value === _remove.value) {
        const { selected, ...val } = op;
        return val;
      }
      return op;
    });

    setPositionOptions((prev) => types);

        let payload = _.clone(jobs);
        let result = update(payload, {
        [index]: {
            job_role: { $set: opt },
        },
        }); //remove
        setJobs(result);
    };

  const createPosition = async (e) => {
    try {
      let { data } = await http.post("public/positions", {
        user_id: profile.user_id,
        user_profile_id: profile.id,
        position: e.label,
      });
      getPositions();
      return data.data;
    } catch (err) {
      console.log(err);
    }
  };

  const onRemoveJobRole = (index) => {
      if (jobs.length === 1) return;

      let payload = _.clone(jobs);
      let result = update(payload, { $splice: [[index, 1]] }); //remove
      setJobs(result);
  
      if (result.length < 5) setBtnAddPositionHidden(false);
      else setBtnAddPositionHidden(true);
    };

    const submit = ()=>{
        hide({success:true, jobs:jobs})
    }

    return(
         <Modal
            width="w-19/20 md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
            contentClassName="rounded-lg overflow-auto custom-scroll"
            wrapperClassName="overflow-visible" 
        >
            <div className="w-full relative">
                <ModalHeader
                    title={t('positionRoleDescription')}
                    hide={hide}
                    showPopInfo
                    popInfoType="add_milestone"
                    padding = "pl-4 pr-7 py-3.5"
                    />

                <div className="px-6 pt-4">
                    <InputGroup
                        title={t('position')}
                        subTitleLeft={t('jobRole')}
                        subTitleRight={t('informationJob')}
                        options={positionOptions}
                        items={jobs}
                        fieldKey="job_role"
                        onChange={(e, index) => onChangeInput(e, index)}
                        onSelect={(e, index) => onSelectJobRole(e, index)}
                        onRemove={(index) => onRemoveJobRole(index)}
                        onAdd={onAddPosition}
                        hideAddButton={btnAddPositionHidden}
                        errors={errorMessages}
                        customClass="marked"
                    />
                </div>
                
                <div className="border-t border-gray py-4 px-4">
                    <div className="w-full flex items-center justify-end 1sm:justify-end space-x-2">
                        <Button
                            buttonName={t('cancel')}
                            buttonClass="bg-thBg py-4 px-8 hover:bg-gray min-w-[7rem]"
                            buttonTextClass="text-black text-sm font-semibold"
                            onClick={() => hide()}
                            // disabled={submitLoading}
                        />
                        <Button
                            key="save-btn-category"
                            buttonName={t('save')}
                            buttonClass="bg-primary py-4 px-8 hover:bg-darkPrimary min-w-[7rem]"
                            buttonTextClass="w-full text-white text-sm font-semibold flex items-center justify-center"
                            onClick={submit}
                        />
                    </div>
                </div> 
            </div>
        </Modal>
    )
}

export default PositionEdit;